module.exports = __webpack_public_path__ + "img/HA2505-150.9a033b54.jpg";